import * as React from 'react'
import {Link} from '@frontrow/console/src/components/ui/link'

import {PATHS} from '@frontrow/console/src/entities/helpers/paths'
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons'
import {Button} from '@frontrow/console/src/components/button'

import SidebarLink from '@frontrow/console/src/components/common/dashboard/sidebar/sidebar-link'
import Restricted from '@frontrow/console/src/components/common/restricted'
import {Routes} from '@frontrow/console/src/routers/routes'
import AgentContext from '@frontrow/console/src/context/agent'
import {logoutConsoleAgent} from '@frontrow/console/src/helpers/auth-helpers'

import {
  sidebar,
  sidebarHeader,
  sidebarLinks,
  sidebarWrapper,
  bottomLinks,
  sidebarBugsLink,
  linksWrapper,
  logoutWrapper,
  logoutButton
} from './sidebar.module.scss'

export default function Sidebar(): React.ReactElement {
  return (
    <div className={sidebar}>
      <div className={`flex flex-col ${sidebarWrapper}`}>
        <div className={sidebarHeader}>
          <Link href={Routes.home()}>
            <img
              src={`${PATHS.imageAssetsUrl}/company-logos/fullcolor-logo-white-wordmark.svg`}
              alt="Freckle"
              title="Freckle"
              className="h-[35px]"
            />
          </Link>
        </div>
        <div className={`flex flex-col justify-between ${linksWrapper}`}>
          <ul className={sidebarLinks}>
            <SidebarLink
              url={Routes.teachers.teachers()}
              title="Teachers"
              dataTest="sidebar-link-teachers"
            />
            <Restricted to="admin">
              <SidebarLink
                url={Routes.students()}
                title="Students"
                dataTest="sidebar-link-students"
              />
            </Restricted>
            <SidebarLink
              url={Routes.schools.schools()}
              title="Schools"
              dataTest="sidebar-link-schools"
            />
            <SidebarLink
              url={Routes.districts.districts()}
              title="Districts"
              dataTest="sidebar-link-districts"
            />
            <SidebarLink
              url={Routes.schoolAdmins.schoolAdmins()}
              title="School Admins"
              dataTest="sidebar-link-school-admins"
            />
            <Restricted to="admin">
              <SidebarLink
                url={Routes.roster()}
                title="Rostering"
                dataTest="sidebar-link-rostering"
              />
            </Restricted>
            <Restricted to="admin">
              <SidebarLink
                url={Routes.items.items()}
                title="Piggy Store"
                dataTest="sidebar-link-piggy-store"
              />
            </Restricted>
            <SidebarLink url={Routes.demoDistrict()} title="Demo" dataTest="sidebar-link-demo" />
            <SidebarLink
              url={Routes.salesReports()}
              title="Sales Reports"
              dataTest="sidebar-link-sales-reports"
            />
            <Restricted to="admin">
              <SidebarLink
                url={Routes.standardSets()}
                title="Standard Sets"
                dataTest="sidebar-link-standard-sets"
              />
            </Restricted>
            <Restricted to="engineering">
              <SidebarLink url={Routes.jobs()} title="Jobs" dataTest="sidebar-link-jobs" />
            </Restricted>
          </ul>

          <div className={bottomLinks}>
            <Link
              target="_blank"
              href="https://illuminate.atlassian.net/jira/software/c/projects/NXSTUX/boards/2521"
              style="btn-warning"
              addClass={sidebarBugsLink}
            >
              FILE A BUG
            </Link>
            <Link
              target="_blank"
              href="https://illuminate.atlassian.net/jira/software/c/projects/CONMATH/boards/5184"
              style="btn-danger"
              addClass={sidebarBugsLink}
            >
              FILE A CONTENT MATH BUG
            </Link>
            <Link
              target="_blank"
              href="https://illuminate.atlassian.net/jira/software/c/projects/CONLIT/boards/3719"
              style="btn-danger"
              addClass={sidebarBugsLink}
            >
              FILE A CONTENT ELA/SS/SCI BUG
            </Link>
          </div>

          <AgentContext.Consumer>
            {agent => (
              <div className={logoutWrapper}>
                <span>{agent.email}</span>
                <Button onClick={logout} leftIcon={faSignOutAlt} addClass={logoutButton}>
                  Logout
                </Button>
              </div>
            )}
          </AgentContext.Consumer>
        </div>
      </div>
    </div>
  )
}

function logout() {
  logoutConsoleAgent().then(() => {
    window.location.href = '/'
  })
}
